var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("e-sidebar", {
        attrs: {
          title: _vm.edit ? _vm.$t("Editar Parceria") : _vm.$t("Nova Parceria"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "80%",
        },
        on: { save: _vm.savePartnership, hidden: _vm.hideSidebar },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "FormulateForm",
                  { ref: "partnershipForm", attrs: { name: "form" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: "partnership-partner-type",
                                type: _vm.isReadOnly ? "label" : "vue-select",
                                label: _vm.$t("Tipo de Parceiro"),
                                options: _vm.partnerTypeOptions,
                                validation: "required",
                              },
                              model: {
                                value: _vm.localPartnership.partnerType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localPartnership,
                                    "partnerType",
                                    $$v
                                  )
                                },
                                expression: "localPartnership.partnerType",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: "partnership-partner-name",
                                type: _vm.isReadOnly ? "label" : "text",
                                label: _vm.$t("Nome do Parceiro"),
                                validation: "required",
                              },
                              model: {
                                value: _vm.localPartnership.partnerName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localPartnership,
                                    "partnerName",
                                    $$v
                                  )
                                },
                                expression: "localPartnership.partnerName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "partnership-cnpj",
                                type: _vm.isReadOnly ? "label" : "text-mask",
                                mask: ["XX.XXX.XXX/XXXX-##"],
                                label: _vm.$t("CNPJ"),
                                validation: "optional|cpfCnpj",
                              },
                              model: {
                                value: _vm.localPartnership.cnpj,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localPartnership, "cnpj", $$v)
                                },
                                expression: "localPartnership.cnpj",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: "partnership-estimated-participants",
                                type: _vm.isReadOnly ? "label" : "number",
                                label: _vm.$t(
                                  "Quantidade Estimada de Participantes"
                                ),
                                validation: "required|min:1",
                                min: "1",
                              },
                              model: {
                                value:
                                  _vm.localPartnership.estimatedParticipants,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localPartnership,
                                    "estimatedParticipants",
                                    $$v
                                  )
                                },
                                expression:
                                  "localPartnership.estimatedParticipants",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: "partnership-verification-field-name",
                                type: _vm.isReadOnly ? "label" : "text",
                                label: _vm.$t("Nome do Campo de Verificação"),
                                instruction: _vm.$t(
                                  "Nome do campo que será usado para verificar se o usuário pertence à parceria (ex: Matrícula, Código do Funcionário, etc.)"
                                ),
                                validation: "required",
                              },
                              model: {
                                value:
                                  _vm.localPartnership.verificationFieldName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localPartnership,
                                    "verificationFieldName",
                                    $$v
                                  )
                                },
                                expression:
                                  "localPartnership.verificationFieldName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "partnership-price-table",
                                type: _vm.isReadOnly ? "label" : "vue-select",
                                label: _vm.$t("Tabela de Preço"),
                                options: _vm.priceTableOptions,
                                placeholder: _vm.$t(
                                  "Selecione uma tabela de preço"
                                ),
                              },
                              model: {
                                value: _vm.localPartnership.priceTableId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localPartnership,
                                    "priceTableId",
                                    $$v
                                  )
                                },
                                expression: "localPartnership.priceTableId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "partnership-key",
                                type: "label",
                                label: _vm.$t("Chave da Parceria (GUID)"),
                                placeholder: _vm.$t("Chave única da parceria"),
                                readonly: true,
                                instruction: _vm.$t(
                                  "Chave única gerada automaticamente para identificar a parceria"
                                ),
                              },
                              model: {
                                value: _vm.localPartnership.key,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localPartnership, "key", $$v)
                                },
                                expression: "localPartnership.key",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "8" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "partnership-url",
                                type: _vm.isReadOnly ? "label" : "url",
                                label: _vm.$t("URL da Parceria"),
                                placeholder: _vm.$t(
                                  "https://exemplo.com/parceria"
                                ),
                              },
                              model: {
                                value: _vm.localPartnership.partnershipUrl,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localPartnership,
                                    "partnershipUrl",
                                    $$v
                                  )
                                },
                                expression: "localPartnership.partnershipUrl",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.localPartnership.partnershipUrl &&
                        _vm.isValidUrl(_vm.localPartnership.partnershipUrl)
                          ? _c(
                              "b-col",
                              {
                                staticClass: "form-group",
                                attrs: { md: "12" },
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "formulate-input-label" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("QR Code da Parceria")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "qr-code-container text-center p-3 border rounded",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "qr-code-wrapper" },
                                      [
                                        _c("canvas", {
                                          ref: "qrCanvas",
                                          staticClass: "qr-code-canvas",
                                          staticStyle: {
                                            "max-width": "200px",
                                            height: "auto",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "mt-2" },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-muted small mb-2",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Escaneie este QR Code para acessar a parceria"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-primary",
                                            },
                                            on: {
                                              click: _vm.copyQRCodeToClipboard,
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-1",
                                              attrs: {
                                                icon: "CopyIcon",
                                                size: "14",
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("Copiar QR Code")
                                                ) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }